import apiService from "./apiService";

export const getAllUsers = () => apiService.get("/users");
export const getUserById = (id) => apiService.get(`/users/${id}`);
export const createUser = (data) => apiService.post("/users", data);
export const updateUser = (id, data) => apiService.put(`/users/${id}`, data);
export const deleteUser = (id) => apiService.delete(`/users/${id}`);
export const resendInvite = (id, restaurant_id) =>
  apiService.post(`/users/resend-invite/${id}`, { restaurant_id });
